const Container = ({ className = '', full = false, children }) => {
    return (
        <div className={`mx-auto md:px-3 px-5 ${full ? 'w-full' : '2xl:w-1300 xl:w-1280 lg:w-1024 md:w-768 w-full' } ` + className}>
            {children}
        </div>
    );
}

export default Container;